module.exports = __webpack_public_path__ + "img/skinxs-logo-small.bdae6186.svg";